import trackVk from '@/helpers/track_vk';

pageLoad('storages_index', () => {
  if (!document.querySelector('.storages-v4-index')) { return; }

  $('a.read-more').on('click', ({ currentTarget }) => {
    $(currentTarget).addClass('active');
    $('.additional-seo .spoiler').addClass('active');
  });

  trackVk('view_storages');
});
